var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1212_1245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2987 6.52904C12.2987 7.03396 12.4993 7.5182 12.8563 7.87523C13.2133 8.23226 13.6976 8.43284 14.2025 8.43284C14.7074 8.43284 15.1917 8.23226 15.5487 7.87523C15.9057 7.5182 16.1063 7.03396 16.1063 6.52904C16.1063 6.02412 15.9057 5.53988 15.5487 5.18285C15.1917 4.82582 14.7074 4.62524 14.2025 4.62524C13.6976 4.62524 13.2133 4.82582 12.8563 5.18285C12.4993 5.53988 12.2987 6.02412 12.2987 6.52904Z",
    stroke: "#16151C",
    strokeWidth: 1.42785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68359 6.52905H12.2988",
    stroke: "#16151C",
    strokeWidth: 1.42785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1063 6.52905H19.9139",
    stroke: "#16151C",
    strokeWidth: 1.42785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5874 12.2405C6.5874 12.7454 6.78798 13.2296 7.14501 13.5867C7.50204 13.9437 7.98628 14.1443 8.4912 14.1443C8.99612 14.1443 9.48036 13.9437 9.83739 13.5867C10.1944 13.2296 10.395 12.7454 10.395 12.2405C10.395 11.7355 10.1944 11.2513 9.83739 10.8943C9.48036 10.5372 8.99612 10.3367 8.4912 10.3367C7.98628 10.3367 7.50204 10.5372 7.14501 10.8943C6.78798 11.2513 6.5874 11.7355 6.5874 12.2405Z",
    stroke: "#16151C",
    strokeWidth: 1.42785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68359 12.2405H6.58739",
    stroke: "#16151C",
    strokeWidth: 1.42785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3949 12.2405H19.9139",
    stroke: "#16151C",
    strokeWidth: 1.42785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1544 17.9519C15.1544 18.4568 15.355 18.941 15.712 19.2981C16.0691 19.6551 16.5533 19.8557 17.0582 19.8557C17.5631 19.8557 18.0474 19.6551 18.4044 19.2981C18.7614 18.941 18.962 18.4568 18.962 17.9519C18.962 17.447 18.7614 16.9627 18.4044 16.6057C18.0474 16.2487 17.5631 16.0481 17.0582 16.0481C16.5533 16.0481 16.0691 16.2487 15.712 16.6057C15.355 16.9627 15.1544 17.447 15.1544 17.9519Z",
    stroke: "#16151C",
    strokeWidth: 1.42785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68359 17.9519H15.1545",
    stroke: "#16151C",
    strokeWidth: 1.42785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.962 17.9519H19.9139",
    stroke: "#16151C",
    strokeWidth: 1.42785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1212_1245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8456,
    height: 22.8456,
    fill: "white",
    transform: "translate(0.875977 0.817627)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterMenu);
export default __webpack_public_path__ + "static/media/filterMenu.8fdd0cb626dcc038bffc1f1f115e7ecb.svg";
export { ForwardRef as ReactComponent };